module.exports = __webpack_public_path__ + "img/medical-report.d38c12a8.svg";